export default __webpack_public_path__ + "static/Toyota_Tagline_Incorrect_Usage_3-6d908109117ccd0e8b0e18c50d3ecc9e.svg";